<div class="submit-ticket-page">
  <header class="page-header">
    <button type="button" mat-icon-button (click)="closeView()" aria-label="Go back">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>Submit Ticket</h1>
  </header>

  <div class="page-content">
    <form [formGroup]="raiseReuqestForm" class="ticket-form">
      <div class="media-upload" (click)="mediaInput.click()">
        <input
          #mediaInput
          type="file"
          accept="image/*,video/*"
          class="media-input"
          (change)="onFileSelect($event)"
        />

        <ng-container *ngIf="!issuePhotoPreview && !issueVideoPreview; else mediaPreview">
          <div class="media-placeholder">
            <span class="media-icon">
              <mat-icon>add_photo_alternate</mat-icon>
            </span>
            <p class="media-title">Add Photo or Video</p>
            <p class="media-subtitle">Tap to upload media</p>
          </div>
        </ng-container>

        <ng-template #mediaPreview>
          <div class="media-preview" (click)="$event.stopPropagation()">
            <img *ngIf="issuePhotoPreview" [src]="issuePhotoPreview" alt="Uploaded preview" />
            <video *ngIf="issueVideoPreview" [src]="issueVideoPreview" controls></video>
            <button type="button" mat-icon-button class="delete-media" (click)="deleteFile()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </ng-template>
      </div>
      <div
        class="field-error"
        *ngIf="raiseReuqestForm.get('issue_photo')?.hasError('required') && raiseReuqestForm.get('issue_photo')?.touched">
        Photo or video is required
      </div>

      <div class="form-row">
        <div class="form-col" [class.form-col--full]="!showSubCategory">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Category"
              formControlName="issue_category_id"
              [options]="categoryList | searchableOptions:'issue_category':'issue_category_id'"
              placeholder="Select Category"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
            <div
              class="field-error"
              *ngIf="raiseReuqestForm.get('issue_category_id')?.hasError('required') && raiseReuqestForm.get('issue_category_id')?.touched">
              Category is required
            </div>
          </div>
        </div>

        <div class="form-col" *ngIf="showSubCategory">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Subcategory"
              formControlName="sub_issue_category_id"
              [options]="subCategoryList | searchableOptions:'issue_category':'issue_category_id'"
              placeholder="Select Subcategory"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
            <div
              class="field-error"
              *ngIf="raiseReuqestForm.get('sub_issue_category_id')?.hasError('required') && raiseReuqestForm.get('sub_issue_category_id')?.touched">
              Subcategory is required
            </div>
          </div>
        </div>
      </div>

      <mat-form-field appearance="outline" class="w-100 ticket-field">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          formControlName="description"
          rows="3"
          placeholder="Description"
        ></textarea>
        <mat-error *ngIf="raiseReuqestForm.get('description')?.hasError('required') && raiseReuqestForm.get('description')?.touched">
          Description is required
        </mat-error>
      </mat-form-field>

      <div class="form-row">
        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Project"
              formControlName="account_id"
              [options]="projectList | searchableOptions:'project_name':'account_id'"
              placeholder="Select Project"
              class="w-100 ticket-dropdown"
              (selectionChange)="onProjectChange($event)"
            ></app-searchable-dropdown>
            <div
              class="field-error"
              *ngIf="raiseReuqestForm.get('account_id')?.hasError('required') && raiseReuqestForm.get('account_id')?.touched">
              Project is required
            </div>
          </div>
        </div>

        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Status"
              formControlName="status"
              [options]="statusList | searchableOptions:'status':'status_id'"
              placeholder="Select Status"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Internal Priority"
              formControlName="priority_id"
              [options]="priorityList | searchableOptions:'priority':'priority_id'"
              placeholder="Select Internal Priority"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>

        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Role"
              formControlName="role_id"
              [options]="roleList | searchableOptions:'role':'role_id'"
              placeholder="Select Role"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Member"
              formControlName="assigned_to"
              [options]="allMembers | searchableOptions:'member_name':'user_id'"
              placeholder="Select Member"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>
      </div>
    </form>
  </div>

  <footer class="page-footer">
    <button
      type="button"
      class="submit-button"
      mat-flat-button
      color="primary"
      (click)="submitRequest()"
      [disabled]="submitting">
      {{ submitting ? 'Submitting...' : 'Submit' }}
    </button>
  </footer>
</div>
